import * as CommonActions from './lib/data-access/+state/actions/landing-page.actions';
import * as CommonFeature from './lib/data-access/+state/reducers/landing-page.reducer';
import * as CommonSelectors from './lib/data-access/+state/selectors/landing-page.selectors';

export { State as CommonState } from './lib/data-access/+state/reducers/landing-page.reducer';
export * from './lib/data-access/facades/state.facade';
export * from './lib/data-access/mocks/index';
export * from './lib/data-access/models/index';
export * from './lib/entry-components/landing-page/landing-page.component';
export * from './lib/smart.module';
export { CommonActions, CommonFeature, CommonSelectors };
